module.exports = __webpack_public_path__ + "static/media/tyre-red-6.48bd7e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-red-6.png
// module id = 1141
// module chunks = 0